import React, { useState, useContext, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Login.scss";
import { signInWithEmail, signInWithGoogle, signInWithFacebook } from "../../Supabase/Config";
import { AuthContext } from "../../Context/AuthContext";
import { IoMdCloseCircle } from "react-icons/io";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { _setAuth } = useContext(AuthContext);

  // Surface OAuth errors that were captured during the provider redirect
  // (the provider redirects back to /chatbot, which forwards the error here).
  useEffect(() => {
    const oauthError = sessionStorage.getItem("oauth_error");
    if (oauthError) {
      setError(oauthError);
      sessionStorage.removeItem("oauth_error");
    }
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailSignIn = async () => {
    setLoading(true);
    setError("");

    if (!validateEmail(email)) {
      setError("Invalid email address.");
      setLoading(false);
      return;
    }

    if (password.trim() === "") {
      setError("Password cannot be empty.");
      setLoading(false);
      return;
    }

    try {
      const { user, session } = await signInWithEmail(email, password);
      
      if (session) {
        sessionStorage.setItem("tokens", "100");
        sessionStorage.setItem("name", user.user_metadata?.full_name || user.email?.split('@')[0] || 'User');
        sessionStorage.setItem("picture", user.user_metadata?.avatar_url || '');
        localStorage.setItem("jwt", session.access_token);
        _setAuth(true);
        navigate("/chatbot");
      }
    } catch (error) {
      console.error("Error during email sign-in:", error);
      
      if (error.message.includes("Invalid login credentials")) {
        setError("Incorrect email or password.");
      } else if (error.message.includes("Email not confirmed")) {
        setError("Please verify your email before signing in.");
      } else {
        setError(error.message || "An error occurred during sign in.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError("");
    try {
      sessionStorage.setItem("oauth_origin", "login");
      await signInWithGoogle();
      // On success the browser is redirected to the provider; no further code runs.
    } catch (error) {
      console.error("Error during Google sign-in:", error);
      setError(error.message || "Failed to sign in with Google.");
      setLoading(false);
    }
  };

  const handleFacebookSignIn = async () => {
    setLoading(true);
    setError("");
    try {
      sessionStorage.setItem("oauth_origin", "login");
      await signInWithFacebook();
      // On success the browser is redirected to the provider; no further code runs.
    } catch (error) {
      console.error("Error during Facebook sign-in:", error);
      setError(error.message || "Failed to sign in with Facebook.");
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="login">
        <div className="block">
          <img className="back" src="/images/login.svg" alt="login" />
        </div>
        <div className="loginForm">
          <Link to="/">
            <img className="exit-logo" src="/images/cross.png" alt="" />
          </Link>

          <div className="title">
            <h3>
              <img src="/images/logo.svg" alt="logo" />
            </h3>
          </div>
          <div>
            <div className="buttons">
              <button onClick={handleGoogleSignIn}>
                <img src="/images/wg.svg" alt="google" />
                Continue With Google
              </button>
              <button onClick={handleFacebookSignIn}>
                <img src="/images/facebook.svg" alt="linkedin" />
                Continue With Facebook
              </button>
            </div>
            <div className="or">
              <p>
                <span>Or sign in with email</span>
              </p>
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Enter your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <img src="/images/f1.svg" alt="img" />
            </div>
            <div className="form-group">
              <input
                type="password"
                name="password"
                id="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <img src="/images/f2.svg" alt="img" />
            </div>
            <div className="forget">
              <Link to="/forget">Forgot Password?</Link>
            </div>
            {error && (
              <p className="error-message">
                <span style={{ marginRight: "15px", fontSize: "25px" }}>
                  <IoMdCloseCircle />
                </span>
                {error}
              </p>
            )}
            <button
              className={`loginBtn ${loading ? "dull-button" : ""}`}
              onClick={handleEmailSignIn}
              disabled={loading}
            >
              {loading ? "Signing in..." : "Sign in with Regal Bot"}
            </button>
          </div>
          <div className="register">
            <p>
              Don't have an account? <Link to="/signUp">Sign Up for Free</Link>
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Login;
